import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    targetId: String
  };

  toggle() {
    const target = document.getElementById(this.targetIdValue);
    if (target) {
      target.classList.toggle("hidden");
      const expanded = !target.classList.contains("hidden");
      this.updateState(expanded);

      if (expanded) {
        target.querySelector("select, input:not([type='hidden']), button, a")?.focus();
      }
    }
  }

  close() {
    const target = document.getElementById(this.targetIdValue);
    if (!target || target.classList.contains("hidden")) return;

    target.classList.add("hidden");
    this.updateState(false);
    this.element.focus();
  }

  updateState(expanded) {
    this.element.setAttribute("aria-expanded", String(expanded));
    this.element.classList.toggle("is-active", expanded);
  }
}
